document.addEventListener("DOMContentLoaded", () => {
  // Attach click handlers to all lightbox images
  document.querySelectorAll("[data-lightbox]").forEach((img) => {
    img.addEventListener("click", () => {
      const src = img.getAttribute("data-lightbox");
      document.getElementById("lightbox").classList.add("active");
      document.getElementById("lightbox-img").src = src;
      document.body.style.overflow = "hidden";
    });
  });

  // Close functionality
  window.closeLightbox = function () {
    document.getElementById("lightbox").classList.remove("active");
    document.body.style.overflow = "auto";
  };

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      window.closeLightbox();
    }
  });
});
